module.exports = __webpack_public_path__ + "static/img/speech_flow.d6f5092.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/speech_flow.gif
// module id = 2SmR
// module chunks = 10